import * as React from 'react'
import { Box, Typography } from '@mui/material'

import '../styles/footer.css'

const Footer = (): JSX.Element => {
  const version = process.env.GATSBY_VERSION || 'dev'
  const buildDate = process.env.GATSBY_BUILD_DATE || ''

  // Format date/time with @ separator
  const formattedDate = buildDate
    ? buildDate.replace(' ', ' @ ')
    : ''

  return (
    <Box component='footer' className='footer' marginTop={15}>
      <Typography variant='h6' align='center'>
        &copy; {new Date().getFullYear()} <span>Cloud Innovation Hub</span>
        <br />
        <Typography variant='h6'>
          Powered by CPS
        </Typography>
        {(version !== 'dev' || buildDate) && (
          <Typography
            sx={{
              fontSize: '8px',
              marginTop: '4px',
              opacity: 0.6
            }}
          >
            Build: {version}
            {formattedDate && ` • ${formattedDate}`}
          </Typography>
        )}
      </Typography>
    </Box>
  )
}

export default Footer
